export default function renderBackdrop() {
  return `<div class="backdrop is-hidden"></div>`;
}
